import React, { FC, useState, useEffect } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'core/types';
import { updateTwoManSiteNotes } from 'core/sites/sitesApi';
import { MAX_LONG_TEXT_LENGTH } from 'core/constants';
import './twoManSiteNotesModal.scss';

const { TextArea } = Input;

interface TwoManSiteNotesModalProps {
    visible: boolean;
    onClose: () => void;
    encryptedId: string;
    initialNotes: string | null;
}

const TwoManSiteNotesModal: FC<TwoManSiteNotesModalProps> = ({
    visible,
    onClose,
    encryptedId,
    initialNotes,
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const [notes, setNotes] = useState(initialNotes || '');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (visible) {
            setNotes(initialNotes || '');
        }
    }, [visible, initialNotes]);

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await dispatch(updateTwoManSiteNotes({ encryptedId, twoManSiteNotes: notes })).unwrap();
            message.success('Two person site notes updated successfully');
            onClose();
        } catch (error) {
            message.error(typeof error === 'string' ? error : 'Failed to update notes');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal
            title="Edit Two Person Site Notes"
            open={visible}
            onCancel={onClose}
            footer={null}
            centered
            width={650}
            wrapClassName="two-man-site-notes-modal">
            <TextArea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Enter two person site notes..."
                maxLength={MAX_LONG_TEXT_LENGTH}
                className="notes-textarea" />
            <div className="modal-buttons">
                <Button
                    type="primary"
                    className="save-button"
                    loading={isSaving}
                    onClick={handleSave}>
                    Save
                </Button>
            </div>
        </Modal>
    );
};

export default TwoManSiteNotesModal;
